import axios from "axios";
import React, { act, useEffect, useState } from "react";
import InventoryIns from "./InventoryIns";
import DemandIns from "./DemandIns";
import { useGlobalContext } from "../../Context/GlobalContext";
import DemandApprovalIns from "./DemandApprovalIns";
import DVSNInventoryIns from "./DVSNInventoryIns";
import CreateDemand from "./CreateDemand";

const StoreInsMaster = () => {
  const urlPrefix = process.env.REACT_APP_URL_PREFIX;
  const [error, setError] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userData } = useGlobalContext();
  const [active, setActive] = useState("Inventory");
  const [stationData, setStationData] = useState([]);
  const [itemData, setItemData] = useState([]);
  const fetchMasterData = async (tableName, setter) => {
    try {
      const response = await axios.get(
        `${urlPrefix}allMasterData?table_name=${tableName}`,
      );

      if (response.data.success) {
        setter(response.data.data);
      }
    } catch (error) {
      console.error(`Failed to fetch ${tableName}:`, error);
      setError(true);
    }
  };

  useEffect(() => {
    const loadData = async () => {
      setLoading(true);

      await Promise.all([
        fetchMasterData("m_store_stations", setStationData),
        fetchMasterData("m_store_item_master", setItemData),
      ]);

      setLoading(false);
    };

    loadData();
  }, []);
  return (
    <div style={{ minHeight: "90vh" }} className="papaDiv">
      <div className="row m-5">
        <div className="d-flex justify-content-center m-2">
          <button
            onClick={() => {
              setActive("Inventory");
            }}
            className="btn btn-sm px-3   border border-2  fw-semibold  shadow-sm rounded-pill"
            style={{
              background: active === "Inventory" ? "#5c5666" : "#fffeff",
              color: active === "Inventory" ? "white" : "black",
            }}
          >
            Inventory
          </button>
          <button
            onClick={() => {
              setActive("Demand");
            }}
            className="btn btn-sm px-3 border border-2 fw-semibold  shadow-sm rounded-pill"
            style={{
              background: active === "Demand" ? "#5c5666" : "#fffeff",
              color: active === "Demand" ? "white" : "black",
            }}
          >
            Demand
          </button>

          <hr />
        </div>
      </div>

      <div className="row">
        {(active === "Inventory" &&
          userData.role === "dataEntry" &&
          userData.desg === "Officer") ||
        userData.role === "admin" ? (
          <div className="">
            <DVSNInventoryIns
              stationData={stationData}
              itemData={itemData}
              active={active}
            />
          </div>
        ) : (active === "Inventory" &&
            userData.role === "dataEntry" &&
            userData.desg === "Staff") ||
          userData.role === "admin" ? (
          <div className="">
            <DVSNInventoryIns
              stationData={stationData}
              itemData={itemData}
              active={active}
            />
          </div>
        ) : // : active === "Demand" &&
        //   userData.role === "admin" &&
        //   userData.desg === "Staff" ? (
        //   <DemandIns
        //     stationData={stationData}
        //     itemData={itemData}
        //     active={active}
        //   />
        // )

        (active === "Demand" &&
            userData.role === "dataEntry" &&
            userData.desg === "Staff") ||
          userData.role === "admin" ? (
          <CreateDemand
            stationData={stationData}
            itemData={itemData}
            active={active}
          />
        ) : (active === "Demand" &&
            userData.role === "dataEntry" &&
            userData.desg === "Officer") ||
          userData.role === "admin" ? (
          <DemandApprovalIns stationData={stationData} itemData={itemData} />
        ) : active === "Unloading" ? (
          <div></div>
        ) : (
          <h6></h6>
        )}
      </div>
    </div>
  );
};
export default StoreInsMaster;
